import { type FC, useState } from 'preact/compat';

import cn from 'clsx';

import { ButtonVariant } from '@/shared/ui/button/types';
import { Button } from '@/shared/ui/button/ui';

interface Props {
  className?: string;
}

// Buggy component to trigger React error boundaries
const BuggyComponent: FC = () => {
  throw new Error('Test error: This is a test for React Error Boundary');
};

export const TestErrorButtons: FC<Props> = ({ className }) => {
  const [showBuggyComponent, setShowBuggyComponent] = useState(false);

  const throwError = () => {
    throw new Error('Test error: This is a test for window.onerror');
  };

  const throwPromiseRejection = () => {
    Promise.reject(new Error('Test error: This is a test for unhandledrejection'));
  };

  return (
    <>
      <div className={cn(className)}>
        <Button variant={ButtonVariant.secondary} onClick={throwError}>
          Trigger JavaScript Error
        </Button>
        <Button variant={ButtonVariant.secondary} onClick={throwPromiseRejection}>
          Trigger Unhandled Promise Rejection
        </Button>
        <Button
          variant={ButtonVariant.secondary}
          onClick={() => setShowBuggyComponent(true)}
        >
          Trigger React Error Boundary
        </Button>
      </div>
      {showBuggyComponent && <BuggyComponent />}
    </>
  );
};
